import React, { FC } from 'react';
import { Card as AntdCard } from 'antd';
import { CardProps } from 'antd/es/card';

export const Card: FC<CardProps> = (props) => {
  return <AntdCard {...props} />;
};
export default Card;
